import { useCallback } from 'react';
import { useAssetRedirectData } from '@theme/js/components/common/Game/hooks/useAssetRedirectData';
import { useNavigate } from '@theme/js/hooks/navigate';
import { useLaunchGame } from '@core/js/hooks/gameLauncher';

export const useOpenGame = (code, winnerRef) => {
    const launchGame = useLaunchGame();
    const { isArticleIdPathPresent, linkToPage } = useAssetRedirectData(code);
    const navigate = useNavigate();

    return useCallback(() => {
        isArticleIdPathPresent
            ? navigate(linkToPage)
            : (() => {
                launchGame({ code, mode: 1 });
                if (winnerRef?.current) {
                    winnerRef.current?.blur();
                }
            })();
    }, [code, launchGame, linkToPage, navigate, isArticleIdPathPresent, winnerRef]);
};
